<template>
    <li title="История поиска" class="search-print">
        <i @click="clickHandle" class="lnr lnr-history"></i>
        <modal v-if="showModal" :close="() => clickHandle()">
            <h3 slot="modalHeader">История поиска</h3>
            <div slot="modalBody">
                <table class="uk-table uk-table-hover" style="width: calc(99% - 15px*2)">
                    <thead>
                        <tr>
                            <th>Время</th>
                            <th>Дата</th>
                            <th>Запрос</th>
                            <th>Параметры запроса</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            @click="() => {rowClickHandle(e)}"
                            v-for="(e, i) in previousSearchArray"
                            :key="i"
                            >
                            <td>{{new Date(e.dateObject).toLocaleTimeString()}}</td>
                            <td>{{new Date(e.dateObject).toLocaleDateString()}}</td>
                            <td>
                                <div v-if="e.filterData && e.filterData.request">{{e.filterData.request}}</div>
                                <div v-else-if="e.cardOgrn">ОГРН: {{e.cardOgrn}}</div>
                            </td>
                            <td v-if="e.selectedFiltersText">
                                <div class="selected-filter" v-if="e.selectedFiltersText.address">Адрес: {{e.selectedFiltersText.address}}</div>
                                <div class="selected-filter" v-if="e.selectedFiltersText.fias && e.selectedFiltersText.fias != 'вся Россия'">Местоположение (ФИАС): {{e.selectedFiltersText.fias}}</div>
                                <div class="selected-filter" v-if="e.selectedFiltersText.okved && e.selectedFiltersText.okved != 'все виды'">Вид деятельности: {{e.selectedFiltersText.okved}}</div>
                                <div class="selected-filter" v-if="e.selectedFiltersText.okfs && e.selectedFiltersText.okfs != 'не выбрана'">Форма собственности: {{e.selectedFiltersText.okfs}}</div>
                                <div class="selected-filter" v-if="e.selectedFiltersText.okopf && e.selectedFiltersText.okopf != 'все компании и ИП'">Организационно-правовая форма: {{e.selectedFiltersText.okopf}}</div>
                                <div class="selected-filter" v-if="e.selectedFiltersText.restFiltersText && e.selectedFiltersText.restFiltersText != 'не заданы'">Прочие фильтры: {{e.selectedFiltersText.restFiltersText}}</div>
                            </td>
                            <td v-else></td>
                            <td>
                                <div v-if="e.selectedFiltersText && e.selectedFiltersText.address">
                                    Запрос по <i>адресу</i> сохранен из проверки контрагентов
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </modal>
    </li>
</template>

<script>
import modal from './../ui/modal.vue'

export default {
    components: { modal },
    data(){
        return { 
            showModal: false
        }
    },
    computed: {
        previousSearchArray() {
            const previousSearchArray = this.$store.state.search.previousSearchArray
            console.log("previousSearchArray from searchHistory", previousSearchArray);
            return previousSearchArray
        }
    },
    methods: {
        rowClickHandle(e) {
            if(e.cardOgrn) {
                // this.showModal = false
                window.open(`/company/${e.cardOgrn}`)
            } else if(e.selectedFiltersText && e.selectedFiltersText.address){
                this.redirectWithAddress({address: e.selectedFiltersText.address, request: e.filterData.request})
            } else {
                this.setFullFilterData(e.filterData)
            }
        },
        redirectWithAddress({address, request}) {
            window.open(`/${address ? `?address=${address}` : ''}${request ? `&request=${request}` : ''}`)
        },
        setFullFilterData(e){
            this.$store.commit('search/resetPagination')
            this.$store.commit('search/setFullFilterData', e)
            this.showModal = false
        },
        clickHandle(){
            this.showModal = !this.showModal
        },
        escPress(e){
            const code = e.keyCode || e.which
            if(code == 27) {
                this.showModal = false
            }
        }
    },
    mounted() {
        document.body.addEventListener('keydown', this.escPress)
    }
}
</script>

<style scoped>
.selected-filter {
    line-height: 20px;
    margin-top: 10px;
}
th {
    font-style: normal;
}
tr {
    cursor: pointer;
}
tr.search-history__row_disabled:hover {
    background: transparent;
}
tbody td {
    font-size: 12px;
}
.search-history__row_disabled {
    color: #555;
    cursor: default;
}
td div p {
    margin: 0;
    padding: 0;
    line-height: normal;
}
table.uk-table.uk-table-hover {
    margin: 15px;
}
</style>